export const runsStatus = [
    'created',
    'driverAssigned',
    'arrivedForPickup',
    'leftForDelivery',
    'arrivedForDelivery',
    'completed'
]